import React from "react";
import Edited_Images from './Edited_Images';


export default function PhotoEditing() {
    return(
        
            <div>
                <h1 className="background__image">Photo Editing</h1>
                <Edited_Images/>
            </div>
        
    );
}
